const updateCreatorAccount = (state, { payload: { creatorAccount } }) => {
	state.creatorAccount = creatorAccount;
};

export default updateCreatorAccount;
